'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { cloneElement, forwardRef, isValidElement } from 'react';
import { cn } from '../../utils/cn';
export const Label = forwardRef(({ className, children, asChild, ...props }, ref) => {
    if (asChild && isValidElement(children)) {
        return cloneElement(children, {
            itemRef: ref,
            ...props,
        });
    }
    return (_jsx("label", { ref: ref, ...props, className: cn('inline cursor-pointer select-none text-body-4 font-medium text-metal-600 dark:text-metal-300', className), children: children }));
});
Label.displayName = 'Label';
